// Hero Carousel
$('.hero_carousel').flickity({
  // options
  cellAlign: 'left',
  contain: true,
  prevNextButtons: false,
  fade: true,
  wrapAround: true,
  autoPlay: 5000
});

// Topbar Carousel
$('.topBar_carousel').flickity({
  // options
  cellAlign: 'left',
  contain: true,
  prevNextButtons: false,
  pageDots: false,
  autoPlay: 5000
});

// Product Image Carousel
$('.product__main--image').flickity({
  // options
  cellAlign: 'left',
  contain: true,
  prevNextButtons: true,
  pageDots: false,
  autoPlay: false,
  fullscreen: true,
  arrowShape: {x0: 10, x1: 60, y1: 50, x2: 60, y2: 50, x3: 30}
});

// Product Thumbnails Carousel
$('.product__thumb--image').flickity({
  // options
  cellAlign: 'left',
  contain: true,
  asNavFor: '.product__main--image',
  prevNextButtons: true,
  pageDots: false,
  autoPlay: false,
  arrowShape: {x0: 10, x1: 60, y1: 50, x2: 60, y2: 50, x3: 30}
});

// Related Product Carousel
$('.related__product--box ').flickity({
  // options
  cellAlign: 'left',
  contain: true,
  prevNextButtons: true,
  pageDots: false,
  autoPlay: false,
  arrowShape: {x0: 10, x1: 60, y1: 50, x2: 60, y2: 50, x3: 30}
});



// setTimeout(function(){});


$(window).scroll(function(){
  scroll = $(window).scrollTop();
  if (scroll >= 40){ 
    $('.header_main_section').addClass('fixed').removeClass('header__transparent');
    $('.collection__filter--bar').addClass('active');    
  }
  else {
    $('.header_main_section').removeClass('fixed').addClass('header__transparent');
    $('.collection__filter--bar').removeClass('active');
  }
});

// collection filter

$('.collection__filter--bar .collection__item__view .item__view').click(function(){
  $(this).addClass('active');
  $(this).siblings().removeClass('active');
});

$('.collection__filter--bar .collection__item__view .item__view#item__view_four').click(function(){
  $('.collection__product--block').addClass('item__view-small');
  $('.collection__product--block').removeClass('item__view-large');
});

$('.collection__filter--bar .collection__item__view .item__view#item__view_two').click(function(){
  $('.collection__product--block').addClass('item__view-large');
  $('.collection__product--block').removeClass('item__view-small');
});

$('.collection__filter--bar .collection__filters .filter__sort--option .filter__sort--list .filter__sort--listItems a').click(function(){
  var sort__value = $(this).attr('data-value');
  //  console.log('sort__value:'+sort__value);  
  $('.filter__sort--option .filters-toolbar__item-child select#SortBy option').val(sort__value).change();
});

$('.collection__filter--bar .collection__filters .filter__sort--option#filterSort').click(function(){
  $(this).children('.filter__sort--list').fadeToggle();
});

// Product Quantity selector 


$("body").on('click','.cdk__quantity_wrap .cdk_qty__btns.cdk_plus', function(){
  console.log('plus');
  var currentVal = parseInt($(this).siblings('input').val());
  if (!isNaN(currentVal)) {
    // Increment
    $(this).siblings('input').val(currentVal + 1);
  }
});
$("body").on('click','.cdk__quantity_wrap .cdk_qty__btns.cdk_minus', function(){
  var currentVal = parseInt($(this).siblings('input').val());
  if (currentVal > 1) {
    $(this).siblings('input').val(currentVal - 1);
  }
});

// cart page checkout t & c

$('body').on('click', '#checkout__btn', function() {
  if ($('#checkout_tc').is(':checked')) {
    $(this).submit();
  }
  else {
    alert("You must agree with the terms and conditions of sales to check out.");
    return false;
  }
});

//   $('body').on('click', '.t_and_c_agree__box label.agree_label', function() {
//     $(this).siblings('#checkout_tc').click();
//   })


function collectionProductsView() {
  if($(window).width() < 500){
      $('.collection__filter--bar .collection__item__view .item__view#item__view_two a').trigger('click');
  }
  else{
      $('.collection__filter--bar .collection__item__view .item__view#item__view_four a').trigger('click');
  }
}
//initialize
collectionProductsView();


$('#mobile_menu--toggle').click(function(){
  $(".cdk__mobile-navigation-overlayer").toggleClass('active');
  $(".cdk__mobile-navigation").toggleClass('active');
})

$('.cdk__mobile-navigation-overlayer').click(function(){
  $(this).removeClass('active');
  $('.cdk__mobile-navigation.active').removeClass('active');
})

$('#mobile_menu--close').click(function(){
  $('.cdk__mobile-navigation-overlayer').removeClass('active');
  $('.cdk__mobile-navigation').removeClass('active');
})


$('.cdk__mobile_navigation--linkBlock.has__sublink .sublink__icon').click(function(){

  $(this).toggleClass('active');
  $(this).siblings('.cdk__mobile-navigation--subLinks').slideToggle();

})


$('#newsletter__popup--close').click(function(){
  $('#newsletter__popup--block, #newsletter__popup--overlay').removeClass('active');  
})

$('#newsletter__popup--overlay').click(function(){
  $(this).removeClass('active');
  $('#newsletter__popup--block').removeClass('active');  
})



var newsletter_popup_status = localStorage.getItem("newsletter_popup_status");   
console.log("newsletter_popup_status :"+newsletter_popup_status); 

if( newsletter_popup_status == '' || typeof newsletter_popup_status == 'undefined' ||  newsletter_popup_status == null ){

  setTimeout(function(){
    $('#newsletter__popup--block, #newsletter__popup--overlay').addClass('active');
  },5000)

}
else
{
	if(newsletter_popup_status == 0){
		 setTimeout(function(){
		    $('#newsletter__popup--block, #newsletter__popup--overlay').addClass('active');
		  },5000)
	}
}

$("#newsletter__popup--close , #newsletter__popup--overlay ").click(function(){
	 $('#newsletter__popup--block, #newsletter__popup--overlay').removeClass('active');
	 localStorage.setItem("newsletter_popup_status",1);
});

$(window).on('load', function() {
  setTimeout(function(){
    $('.lazy_load').each(function(i){
      var imageSrc = $(this).attr('data-src');
      $(this).attr('src' , imageSrc).removeClass('blur');
    },500);
  });
  
});